import React, { useState, useRef, useContext, useEffect } from "react";
import clsx from "clsx";

import {
  makeStyles,
  Drawer,
  AppBar,
  Toolbar,
  List,
  Typography,
  Divider,
  MenuItem,
  IconButton,
  Menu,
} from "@material-ui/core";

import RefreshIcon from "@material-ui/icons/Refresh";
import FileCopy from "@material-ui/icons/FileCopy";
import DashBoard from "@material-ui/icons/Dashboard";
import MenuIcon from "@material-ui/icons/Menu";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import AccountCircle from "@material-ui/icons/AccountCircle";

import MainListItems from "./MainListItems";
import NotificationsPopOver from "../components/NotificationsPopOver";
import UserModal from "../components/UserModal";
import { AuthContext } from "../context/Auth/AuthContext";
import BackdropLoading from "../components/BackdropLoading";
import { i18n } from "../translate/i18n";
import useSound from "use-sound";
import alertSound from "../assets/sound.mp3";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    height: "100vh",
    [theme.breakpoints.down("sm")]: {
      height: "calc(100vh - 56px)",
    },
  },

  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 8px",
    minHeight: "48px",
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: "none",
  },
  title: {
    flexGrow: 1,
  },
  drawerPaper: {
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9),
    },
  },
  appBarSpacer: {
    minHeight: "48px",
  },
  content: {
    flex: 1,
    overflow: "auto",
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
}));

const LoggedInLayout = ({ children }) => {
  const classes = useStyles();
  const [userModalOpen, setUserModalOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const { handleLogout, loading } = useContext(AuthContext);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [drawerVariant, setDrawerVariant] = useState("permanent");
  const { user } = useContext(AuthContext);

  function showBrowserNotification({ title, body, icon, url }) {
    console.log("entrei showBrowserNotification");
    try {
      if (!("Notification" in window)) {
        console.error("Este navegador não suporta notificações.");
        return;
      }
      if (Notification.permission !== "granted") {
        console.error("Permissão de notificação não concedida.");
        return;
      }

      const notification = new Notification(title || "Notificação", {
        body: body || "",
        icon: icon || "/favicon.png",
      });

      notification.onclick = () => {
        try {
          window.focus();
          if (url) window.location.href = url;
          notification.close();
        } catch (err) {
          console.error("Erro ao tratar clique da notificação:", err);
        }
      };

    } catch (err) {
      console.error("Erro ao criar notificação:", err);
    }
  }

  useEffect(() => {
    if (document.body.offsetWidth > 600) {
      setDrawerOpen(true);
    }
  }, []);

  useEffect(() => {
    if (document.body.offsetWidth < 600) {
      setDrawerVariant("temporary");
    } else {
      setDrawerVariant("permanent");
    }
  }, [drawerOpen]);

  const userIdv2 = user?.id;
  const [play] = useSound(alertSound);
  const soundAlertRef = useRef();

  useEffect(() => {
      soundAlertRef.current = play;

      if (!("Notification" in window)) {
        console.log("This browser doesn't support notifications");
      } else {
        Notification.requestPermission();
      }
  }, [play]);

  useEffect(() => {
    if (process.env.REACT_APP_ENABLE_LEGACY_NOTIFICATION_POLLING !== "true") return;
    const interval = setInterval(() => {
      const verificarFila = async () => {
        console.log("Entrei");
        try {

          if (!userIdv2) return;

          const url = `https://wtoolteste.brs.com.br/gui_reif/Whaticket/analisaNotificacoes/${userIdv2}`;

          console.log("Fazendo fetch para URL1:", url);

          const response = await fetch(url, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          });
        
          let resposta = await response.json();
          if(resposta.response === "notificar"){
            //console.log("Devo notificar!"); 
            soundAlertRef.current();

            showBrowserNotification({
              title: "Nova mensagem!",
              body: "Você recebeu uma mensagem no Bot WhatsApp ",
              url: "/chat/123"
            });

          }else{
            //console.log("Não devo notificar!"); 
            
          }
        
        } catch (error) {
          console.error("Erro ao verificar fila:", error.message);
        }
      };

      verificarFila();
    }, 1 * 35 * 1000); // a cada 35seg
    return () => clearInterval(interval);
  }, [userIdv2]);

useEffect(() => {
  if (process.env.REACT_APP_ENABLE_LEGACY_NOTIFICATION_POLLING !== "true") return;
  const interval = setInterval(() => {
    const verificarFila = async () => {
      console.log("Entrei");
      try {
        if (!userIdv2) return;

        const url = `https://wtoolteste.brs.com.br/gui_reif/Whaticket/atualizarSeHaTicketsAberto/${userIdv2}`;

        console.log("Fazendo fetch para URL1:", url);

        const response = await fetch(url, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          console.error("Erro na resposta do servidor:", response.status, response.statusText);
          return;
        }

        console.log("Fazendo fetch para URL2:", url);

        const data = await response.json();
        console.log("Resposta recebida:", data);

        if (data?.response === "nao_tem_registro") {
          window.location.reload();
        }
      } catch (error) {
        console.error("Erro ao verificar fila:", error.message);
      }
    };

    verificarFila();
  }, 10 * 60 * 1000); // a cada 5 minutos

  return () => clearInterval(interval);
}, [userIdv2]);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
    setMenuOpen(true);
  };

  const handleFile = () => {
    window.open("http://185.133.250.252:81/php_teste/telaBaixarCsv.php", "_blank");
  };

  const handleDashBoard = () => {
    window.open("http://185.133.250.252:81/php_teste/dashBoardView.php", "_blank");
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setMenuOpen(false);
  };

  const handleOpenUserModal = () => {
    setUserModalOpen(true);
    handleCloseMenu();
  };

  const handleClickLogout = () => {
    handleCloseMenu();
    handleLogout();
  };

  const drawerClose = () => {
    if (document.body.offsetWidth < 600) {
      setDrawerOpen(false);
    }
  };

  if (loading) {
    return <BackdropLoading />;
  }

  return (
    <div className={classes.root}>
      <Drawer
        variant={drawerVariant}
        className={drawerOpen ? classes.drawerPaper : classes.drawerPaperClose}
        classes={{
          paper: clsx(
            classes.drawerPaper,
            !drawerOpen && classes.drawerPaperClose
          ),
        }}
        open={drawerOpen}
      >
        <div className={classes.toolbarIcon}>
          <IconButton onClick={() => setDrawerOpen(!drawerOpen)}>
            <ChevronLeftIcon />
          </IconButton>
        </div>
        <Divider />
        <List>
          <MainListItems drawerClose={drawerClose} />
        </List>
        <Divider />
      </Drawer>
      <UserModal
        open={userModalOpen}
        onClose={() => setUserModalOpen(false)}
        userId={user?.id}
      />
      <AppBar
        position="absolute"
        className={clsx(classes.appBar, drawerOpen && classes.appBarShift)}
        color={process.env.NODE_ENV === "development" ? "inherit" : "primary"}
      >
        <Toolbar variant="dense" className={classes.toolbar}>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="open drawer"
            onClick={() => setDrawerOpen(!drawerOpen)}
            className={clsx(
              classes.menuButton,
              drawerOpen && classes.menuButtonHidden
            )}
          >
            <MenuIcon />
          </IconButton>
          <Typography
            component="h1"
            variant="h6"
            color="inherit"
            noWrap
            className={classes.title}
          >
            {process.env.REACT_APP_TITLE}
          </Typography>
          {user.id && <NotificationsPopOver />}

          <div>
          <IconButton color="inherit" onClick={() => window.location.reload()}>
           
              <RefreshIcon /> {/* Você pode trocar esse ícone por outro */}
         
          </IconButton>
          </div>

          <div>
            <IconButton color="inherit" onClick={handleFile}>
            
                <FileCopy /> {/* Você pode trocar esse ícone por outro */}
          
            </IconButton>
          </div>

          <div>
            <IconButton color="inherit" onClick={handleDashBoard}>
            
                <DashBoard /> {/* Você pode trocar esse ícone por outro */}
          
            </IconButton>
          </div>
          
          <div>
            <IconButton
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleMenu}
              color="inherit"
            >
              <AccountCircle />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              getContentAnchorEl={null}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={menuOpen}
              onClose={handleCloseMenu}
            >
              <MenuItem onClick={handleOpenUserModal}>
                {i18n.t("mainDrawer.appBar.user.profile")}
              </MenuItem>
              <MenuItem onClick={handleClickLogout}>
                {i18n.t("mainDrawer.appBar.user.logout")}
              </MenuItem>
            </Menu>
          </div>
        </Toolbar>
      </AppBar>
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />

        {children ? children : null}
      </main>
    </div>
  );
};

export default LoggedInLayout;
